
<template>
  <mk-drawer
    class="get-url-tips"
    :visible="show"
    direction="rtl"
    size="500px"
    hide-header
    :before-close="cancel"
  >
    <div class="header">
      <h3>如何获取文章链接</h3>
      <mk-iconfont
        class="icon"
        icon-class="guanbi"
        @click.native="cancel"
      ></mk-iconfont>
    </div>
    <div class="content">
      <ul>
        <li>
          <span>1、打开准备转载的文章，点击屏幕右上角「...」</span>
          <img src="@/assets/images/getUrlTips1.png">
        </li>
        <li>
          <span>2、在弹出的菜单选择「复制链接」</span>
          <img src="@/assets/images/getUrlTips2.png">
        </li>
        <li>
          <span>3、异常情况：文章中的视频、音频可能会导致转载的显示异常</span>
        </li>
        <li>
          <div class="line"></div>
          <p>免责声明</p>
          <div class="item">
            1、生成转载文章请确认版权问题。对于引起的追诉问题，平台不承担任何责任<br /> 2、为维护原作者版权，如原作者追诉版权，平台将下线生成的转载文章。<br /><br /> 文章版权归原作者所有，请联系原作者申请授权。 <br />如您发现内容存在版权问题，请联系我们，我们将第一时间予以处理。
          </div>
        </li>
      </ul>
    </div>
  </mk-drawer>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.get-url-tips {
  .header {
    height: 60px;
    box-sizing: border-box;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    background: rgb(251, 252, 253);

    h3 {
      font-size: 16px;
      line-height: 22px;
      color: #262626;
    }

    .icon {
      color: #bfbfbf;
      cursor: pointer;
    }
  }

  .content {
    width: calc(100% - 40px);
    height: calc(100vh - 60px);
    background: #fafafa;
    overflow-y: auto;
    margin: 0 auto;

    ul {
      li {
        margin-top: 24px;

        span {
          font-size: 13px;
          color: #262626;
        }

        img {
          display: block;
          width: 100%;
          margin-top: 14px;
        }

        p {
          color: #262626;
          font-size: 14px;
          line-height: 14px;
          margin-bottom: 10px;
          font-weight: 500;
        }

        div.line {
          width: 100%;
          height: 1px;
          background-color: #d9d9d9;
          margin-bottom: 24px;
        }

        div.item {
          font-size: 13px;
          line-height: 18px;
          color: #262626;
          margin-bottom: 16px;
        }
      }
    }
  }
}
</style>
